/* eslint-disable no-console */
export function logError(...args: unknown[]) {
  console.error(...args);
}
